import styles from './styles.module.scss';
import { Header } from './Header';
import styled from 'styled-components';
import { ProductBasedPreviewLayoutTemplates } from './ProductBasedPreviewLayoutTemplates';
import { useState } from 'react';
import cn from 'classnames';
import { Sidebar } from './Sidebar';
import { useWindowResize } from '../../../utils/hooks/useWindowResize';
import { Icon } from '../../../../../../../features/Icon';

const TABLET_WIDTH = 850;

// eslint-disable-next-line max-lines-per-function
export function ProductBasedFinder({
  colors,
  isAudioGuidePlaying,
  playAudio,
  pauseAudio,
  setAudioGuideModal,
  header,
  pagesFlow,
  footer,
  fonts,
  setPagesFlow,
  media,
  chapterIconMedia,
  bulletIcons,
  fontsForLoading,
  showChapterIds,
  setShowChapterIds,
  audioGuideModal,
  isAutoGuide,
}) {
  const { windowWidth } = useWindowResize();
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [pageHistory, setPageHistory] = useState([]);
  const [showSidebarTablet, setShowSidebarTablet] = useState(false);

  const isTablet = windowWidth <= TABLET_WIDTH;

  const { allPages = [], currentPageId, currentElementsIds = [] } = pagesFlow || {};
  const currentPage = allPages.find(page => page.id === currentPageId);

  const handleToggleSidebarTablet = () => {
    setShowSidebarTablet(prev => !prev);
  };

  const currentElements = currentPage?.elements ? currentPage.elements.filter(el => currentElementsIds.includes(el.id)) : [];
  const isResultPage = currentElements?.some(el => el?.templateType === 'RESULT');
  const sidebar = (
    <Sidebar
      pagesFlow={pagesFlow}
      colors={colors}
      showChapterIds={showChapterIds}
      fonts={fonts}
      setPagesFlow={setPagesFlow}
      setPageHistory={setPageHistory}
      currentElements={currentElements}
      chapterIconMedia={chapterIconMedia}
      handleToggleSidebarTablet={handleToggleSidebarTablet}
      footer={footer}
    />
  );
  const shouldShowDesktopSidebar = sidebarVisible && !isTablet;
  const shouldShowTabletControls = sidebarVisible && isTablet;

  return (
    <Root className={cn(styles.wrapper, sidebarVisible && styles.wrapper_withSidebar)} style={{ backgroundColor: colors.backgroundColorSecond }}>
      <Header
        isAudioGuidePlaying={isAudioGuidePlaying}
        playAudio={playAudio}
        pauseAudio={pauseAudio}
        setAudioGuideModal={setAudioGuideModal}
        backgroundColor={colors[header?.backgroundColor]}
        header={header}
        pagesFlow={pagesFlow}
        footer={footer}
        colors={colors}
        textLinkStyles={{
          ...fonts.textLink,
          color: colors[fonts.textLink.colorVariant],
        }}
        setPagesFlow={setPagesFlow}
      />

      <div className={styles.inner}>
        {shouldShowDesktopSidebar && (
          <aside className={styles.sidebar} style={{ backgroundColor: colors?.backgroundColor }}>
            {sidebar}
          </aside>
        )}

        {shouldShowTabletControls && (
          <button type='button' className={styles.hamburger} onClick={handleToggleSidebarTablet}>
            <Icon icon='hamburger' width={18} height={16} fill={showSidebarTablet ? '#0066B3' : '#5C5C6E'} />
          </button>
        )}

        {shouldShowTabletControls && (
          <div
            className={cn(styles.sidebarTablet, showSidebarTablet && styles.sidebarTablet_show)}
            style={{ backgroundColor: colors?.backgroundColor }}
          >
            {sidebar}
          </div>
        )}

        <main
          style={{
            backgroundColor: colors?.backgroundColor,
            border: isResultPage ? '1px solid #E4EBF3' : 'none',
          }}
          className={cn(
            styles.main,
            sidebarVisible && styles.main_withBorder,
            sidebarVisible && isTablet && styles.main_sidebarVisibletablet,
            isTablet && styles.main_tablet
          )}
        >
          <ProductBasedPreviewLayoutTemplates
            pagesFlow={pagesFlow}
            setPagesFlow={setPagesFlow}
            colors={colors}
            fonts={fonts}
            media={media}
            chapterIconMedia={chapterIconMedia}
            bulletIcons={bulletIcons}
            fontsForLoading={fontsForLoading}
            showChapterIds={showChapterIds}
            setShowChapterIds={setShowChapterIds}
            setSidebarVisible={setSidebarVisible}
            pageHistory={pageHistory}
            setPageHistory={setPageHistory}
            currentElements={currentElements}
            audioGuideModal={audioGuideModal}
            isAutoGuide={isAutoGuide}
            footer={footer}
          />
        </main>
      </div>
    </Root>
  );
}

const Root = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  '&, div, span, p, h1, h2, h3, h4, h5, h6': {
    wordBreak: 'break-word',
  },
});
